<template>
  <div class="mainAuxPage zj-flex-column">
    <div class="zj-flex-row">
      <!-- 讲座中心 -->
      <div
        style="border: 1.5px solid rgb(221 221 221);display: flex;flex: 1;margin-right:7px;box-shadow: 0 0 3px rgba(188,  186,  186,  0.8);">
        <div class="zj-flex-column">
          <div class="zj-tbar"
            style="margin-bottom: 0;background-color: #e5e5e5;border-bottom: 3px solid rgb(221 221 221);">
            <div class="zj-flex-row" style="justify-content: space-between;align-items: center;">
              <div style="display: flex;flex-direction: row;margin: 5px 10px;align-items: center;">
                <div class="zj-flex-ceter">
                  <!-- <i style="font-size: 30px;margin-right: 10px;color: #409EFF;" class="el-icon-s-opportunity"></i> -->
                  <img style="width: 25px;height: 25px;margin-right: 10px" src="/static/base/img/通知.png">
                </div>
                <div style="font-weight: 600;color: #409EFF;">大赛公告</div>
              </div>
              <div style="display: flex;flex-direction: row;margin-right: 10px;">
                <el-button icon="el-icon-more" title="更多" size="mini" circle @click="gotoLecture()"></el-button>
                <el-button icon="el-icon-refresh" title="刷新" size="mini" circle
                  @click="refreshLectureData(1)"></el-button>
              </div>
            </div>
          </div>
          <div style="padding:5px 30px;display: flex;flex: 1;background-color: white;">
            <zj-table ref="lectureTable" :data="lectureData" :show-header="false" :border="false"
              :highlight-current-row="false" @row-click="openLectureDetail"
              :row-style="{ height: '40px', color: '#8d9196' }">
              <el-table-column width="40">
                <template slot-scope="scope">
                  <div class="zj-flex-right">
                    <div style="display: flex;align-items: right;margin-right: 10px;"
                      v-if="(new Date().getTime() - new Date(scope.row.start_time).getTime()) / (1000 * 3600 * 24) < 7">
                      <img style="width: 25px;height: 25px;" src="/static/base/img/huo.png">
                    </div>
                    <div style="display: flex;align-items: right;margin-right: 10px;"
                      v-else-if="(new Date(scope.row.end_time).getTime() - new Date().getTime()) / (1000 * 3600 * 24) < 2">
                      <img style="width: 25px;height: 25px;" src="/static/base/img/已结束.png">
                    </div>
                    <div style="display: flex;align-items: right;margin-right: 10px;" v-else>
                      <img style="width: 25px;height: 25px;" src="/static/base/img/competition.png">
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="emp_researchfiled"  label="研究领域"  align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="custom-link">
                    <div class="zj-flex-row" style="justify-content: space-between;">
                      <div style="display: flex;align-items: center;flex:1;flex-direction: row;">
                        <!-- <div v-if="scope.row.emp_researchfiled != null">
                          {{ scope.row.p_no }}{{ "-【" + scope.row.p_name + "】" }}
                        </div>
                        <div v-else>
                          {{ scope.row.p_no }}{{ "-【" + scope.row.p_name + "】" }}
                        </div> -->
                        {{ scope.row.pi_sponsor }}{{ "-【" + scope.row.pi_title + "】" }}
                      </div>
                      <div>
                        报名时间:{{ scope.row.start_time | dateFilter("yyyy/MM/dd") }}~{{
                  scope.row.end_time | dateFilter("yyyy/MM/dd") }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="competition_startdate"  label="报名时间"  align="center" show-overflow-tooltip
                width="280px">
                <template slot-scope="scope">
                  
                </template>
              </el-table-column> -->
              <!--  <el-table-column align-items="left">
                <template slot-scope="scope">
                  <div class="zj-flex-center">
                    <i style="color:#409EFF;font-size: 16px;" class="el-icon-info"
                      @click="openLectureDetail(scope.row)"></i>
                  </div>
                </template>
              </el-table-column> -->
              <el-table-column width="-1"></el-table-column>
            </zj-table>
          </div>
        </div>
      </div>
      <!-- 课程中心 -->
      <!-- <div
        style="border: 1.5px solid rgb(221 221 221);display: flex;flex: 1;margin-left: 7px; box-shadow: 0 0 3px rgba(188,  186,  186,  0.8);">
        <div class="zj-flex-column">
          <div class="zj-tbar"
            style="margin-bottom: 0;background-color: #e5e5e5;border-bottom: 3px solid rgb(221 221 221);">
            <div class="zj-flex-row" style="justify-content: space-between;align-items: center;">
              <div style="display: flex;flex-direction: row;margin: 5px 10px;align-items: center;">
                <div class="zj-flex-ceter">
                  <img style="width: 25px;height: 25px;margin-right: 10px" src="/static/base/img/通知.png">
                </div>
                <div style="font-weight: 600;color: #409EFF;">课程热点</div>
              </div>
              <div style="display: flex;flex-direction: row;margin-right: 10px;">
                <el-button icon="el-icon-more" title="更多" size="mini" circle @click="gotoCourse()"></el-button>
                <el-button icon="el-icon-refresh" title="刷新" size="mini" circle
                  @click="refreshCourseData()"></el-button>
              </div>
            </div>
          </div>
          <div style="padding:5px 30px;display: flex;flex: 1;background-color: white;">
            <zj-table ref="courseTable" class="custom-table" :data="courseData" :show-header="false" :border="false"
              :highlight-current-row="false" @row-click="openCourseDetail"
              :row-style="{ height: '40px', color: '#8d9196' }">
              <el-table-column width="40">
                <template slot-scope="scope">
                  <div class="zj-flex-right">
                    <div style="display: flex;align-items: center;margin-right: 15px;"
                      v-if="(new Date().getTime() - new Date(scope.row.competition_startdate).getTime()) / (1000 * 3600 * 24) < 10">
                      <img style="width: 25px;height: 25px;" src="/static/base/img/newIcon.png">
                    </div>
                    <div style="display: flex;align-items: center;margin-right: 15px;" v-else>
                      <img style="width: 25px;height: 25px;" src="/static/base/img/已结束灰.png">
                    </div>
                  </div>

                </template>
              </el-table-column>
              <el-table-column prop="emp_researchfiled"  label="研究领域"  align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="custom-link">
                    <div class="zj-flex-row" style="justify-content: space-between;">
                      <div style="display: flex;align-items: center;flex:1;flex-direction: row;">
                        {{ "《" + scope.row.p_name + "》" }}, 编号:{{ scope.row.p_no }}, 老师:{{ scope.row.emp_name }}
                      </div>
                      <div>
                        报名时间:{{ scope.row.competition_startdate | dateFilter("yyyy/MM/dd") }} ~ {{
                  scope.row.competition_enddate | dateFilter("yyyy/MM/dd") }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="-1"></el-table-column>
            </zj-table>
          </div>
        </div>
      </div> -->
      <!-- 活动公告 -->
      <div
        style="border: 1.5px solid rgb(221 221 221);display: flex;flex: 1;margin-left: 7px; box-shadow: 0 0 3px rgba(188,  186,  186,  0.8);">
        <div class="zj-flex-column">
          <div class="zj-tbar"
            style="margin-bottom: 0;background-color: #e5e5e5;border-bottom: 3px solid rgb(221 221 221);">
            <div class="zj-flex-row" style="justify-content: space-between;align-items: center;">
              <div style="display: flex;flex-direction: row;margin: 5px 10px;align-items: center;">
                <div class="zj-flex-ceter">
                  <img style="width: 25px;height: 25px;margin-right: 10px" src="/static/base/img/通知.png">
                </div>
                <div style="font-weight: 600;color: #409EFF;">活动公告</div>
              </div>
              <div style="display: flex;flex-direction: row;margin-right: 10px;">
                <el-button icon="el-icon-more" title="更多" size="mini" circle @click="gotoCourse()"></el-button>
                <el-button icon="el-icon-refresh" title="刷新" size="mini" circle
                  @click="refreshLectureData(2)"></el-button>
              </div>
            </div>
          </div>
          <div style="padding:5px 30px;display: flex;flex: 1;background-color: white;">
            <zj-table ref="courseTable" :data="courseData" :show-header="false" :border="false"
              :highlight-current-row="false" @row-click="openLectureDetail"
              :row-style="{ height: '40px', color: '#8d9196' }">
              <el-table-column width="40">
                <template slot-scope="scope">
                  <div class="zj-flex-right">
                    <div style="display: flex;align-items: right;margin-right: 10px;"
                      v-if="(new Date().getTime() - new Date(scope.row.start_time).getTime()) / (1000 * 3600 * 24) < 7">
                      <img style="width: 25px;height: 25px;" src="/static/base/img/huo.png">
                    </div>
                    <div style="display: flex;align-items: right;margin-right: 10px;"
                      v-else-if="(new Date(scope.row.end_time).getTime() - new Date().getTime()) / (1000 * 3600 * 24) < 2">
                      <img style="width: 25px;height: 25px;" src="/static/base/img/已结束.png">
                    </div>
                    <div style="display: flex;align-items: right;margin-right: 10px;" v-else>
                      <img style="width: 25px;height: 25px;" src="/static/base/img/competition.png">
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="emp_researchfiled"  label="研究领域"  align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="custom-link">
                    <div class="zj-flex-row" style="justify-content: space-between;">
                      <div style="display: flex;align-items: center;flex:1;flex-direction: row;">
                        <!-- <div v-if="scope.row.emp_researchfiled != null">
                          {{ scope.row.p_no }}{{ "-【" + scope.row.p_name + "】" }}
                        </div>
                        <div v-else>
                          {{ scope.row.p_no }}{{ "-【" + scope.row.p_name + "】" }}
                        </div> -->
                        {{ scope.row.pi_sponsor }}{{ "-【" + scope.row.pi_title + "】" }}
                      </div>
                      <div>
                        报名时间:{{ scope.row.start_time | dateFilter("yyyy/MM/dd") }}~{{
                  scope.row.end_time | dateFilter("yyyy/MM/dd") }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="competition_startdate"  label="报名时间"  align="center" show-overflow-tooltip
                width="280px">
                <template slot-scope="scope">
                  
                </template>
              </el-table-column> -->
              <!--  <el-table-column align-items="left">
                <template slot-scope="scope">
                  <div class="zj-flex-center">
                    <i style="color:#409EFF;font-size: 16px;" class="el-icon-info"
                      @click="openLectureDetail(scope.row)"></i>
                  </div>
                </template>
              </el-table-column> -->
              <el-table-column width="-1"></el-table-column>
            </zj-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 讲座详情 -->
    <el-dialog width="800px" title="大赛详情"  :visible.sync="showLectureDetail">
      <zj-form :model="lectureContent" label-width="150px" ref="lectureForm">
        <div class="dialog-form">
          <el-form-item class="custom-form-item" label="名称:" prop="pi_title" style="width:650px;">{{
                  lectureContent.pi_title
                }}</el-form-item>
          <el-form-item class="custom-form-item" label="主办单位:" prop="pi_sponsor" style="width:650px;">{{ lectureContent.pi_sponsor
            }}</el-form-item>
          <!-- <el-form-item class="custom-form-item" label="讲座地点:" prop="pp_location" style="width:370px;">{{
            lectureContent.pp_location
          }}</el-form-item> -->
        </div>
        <!-- <div class="dialog-form">
          <el-form-item class="custom-form-item" label="讲师:" prop="emp_name" style="width:370px;">{{
            lectureContent.emp_name }}</el-form-item>
          <el-form-item class="custom-form-item" label="研究领域:" prop="emp_researchfiled" style="width:370px;">{{
            lectureContent.emp_researchfiled
          }}</el-form-item>
        </div> -->
        <div class="dialog-form">
          <el-form-item class="custom-form-item" label="报名开始时间:" prop="start_time" style="width:650px;">{{
                    lectureContent.start_time | dateFilter('yyyy-MM-dd HH:mm') }}</el-form-item>
          <el-form-item class="custom-form-item" label="报名结束时间:" prop="end_time" style="width:650px;">{{
                  lectureContent.end_time | dateFilter('yyyy-MM-dd HH:mm') }}</el-form-item>
        </div>
        <!-- <div class="dialog-form">
          <el-form-item class="custom-form-item" label="讲座日期:" prop="pp_date" style="width:370px;">{{
            lectureContent.pp_date |
            dateFilter('yyyy-MM-dd') }}</el-form-item>
          <el-form-item class="custom-form-item" label="节次:" prop="pp_section_seq" style="width:370px;">{{ '第' +
            lectureContent.pp_section_seq +
            '节' }}</el-form-item>
        </div> -->
        <!--  <el-form-item class="custom-form-item" label="主题标签:" prop="checkLabel" style="width: 740px">
          <template>
            <div style="display:flex;flex:1;flex-direction:row;flex-flow:wrap">
              <div v-for="item in checkLabel" style="margin:0 10px">
                <el-tag>{{ item }}</el-tag>
              </div>
            </div>
          </template>
        </el-form-item> -->
        <div class="dialog-form">
          <el-form-item label="介绍:" prop="pi_content" style="width: 650px;">
            <template>
              <div class="right_editor">
                <!-- <zj-html-editor v-model="lectureContent.pi_content" :ref="'contentEditor'"
                  style="width:100%;border-style:none!important;height:100%!important"
                  :customUploadImg="customUploadImg">
                </zj-html-editor> -->
                <p v-html="lectureContent.pi_content"></p>
              </div>
            </template>
          </el-form-item>
        </div>
      </zj-form>
    </el-dialog>
    <el-dialog width="800px" title="课程详情"  :visible.sync="showCourseDetail">
      <zj-form :model="courseContent" label-width="150px" ref="courseForm">
        <div class="dialog-form">
          <el-form-item class="custom-form-item" label="课程名称：" prop="p_name" style="width:650px;">{{
                  courseContent.p_name
                }}</el-form-item>
          <el-form-item class="custom-form-item" label="讲师：" prop="emp_name" style="width:650px;">{{
                    courseContent.emp_name }}</el-form-item>
        </div>
        <div class="dialog-form">
          <el-form-item label="课程说明：" prop="p_note" style="width:740px;">
            <template>
              <div
                style="display:flex;flex:1;flex-direction:row;flex-flow:wrap;letter-spacing:0.1em;line-height:18px;align-items: center;min-height: 40px;">
                {{ courseContent.p_note }}
              </div>
            </template>
          </el-form-item>
          <!-- <el-form-item label="课程说明：" prop="p_note" style="width:370px;">{{ lectureContent.p_note }}</el-form-item> -->

        </div>
        <div class="dialog-form">
          <el-form-item class="custom-form-item" label="报名开始时间：" prop="competition_startdate" style="width:650px;">{{
                  courseContent.competition_startdate | dateFilter('yyyy-MM-dd HH:mm') }}</el-form-item>
          <el-form-item class="custom-form-item" label="报名结束时间：" prop="competition_enddate" style="width:650px;">{{
                  courseContent.competition_enddate | dateFilter('yyyy-MM-dd HH:mm') }}</el-form-item>
        </div>
      </zj-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vueQr from 'vue-qr';

export default {
  components: {
    vueQr,
  },

  data() {
    return {
      lectureData: [],
      courseData: [],
      showLectureDetail: false,
      showCourseDetail: false,
      lectureContent: {},
      courseContent: {},
      checkLabel: []
    };
  },
  computed: {
    ...mapState(["accountInfo"]),
  },
  methods: {
    //刷新表格数据（带筛选条件）
    refreshLectureData(type) {
      if (type == 1) {
        this.lectureData = [];
      }else{
        this.courseData = [];
      }
      this.z_get(
        "api/project_invitation/GetAllInvitationList",
        {
          condition: this.condition, //左侧为后台参数名，右侧为前端参数名，需配对
          limit: 10,
          page: 1,
          project_type: type,
          orderby: "create_date desc"
        },
        { loading: this.$refs.lectureTable }
      )
        .then(res => {
          for (let i = 0; i < res.data.length; i++) {
            // if (new Date(res.data[i].competition_startdate).getTime() < new Date().getTime() && new Date(res.data[i].competition_enddate).getTime() > new Date().getTime()) {
            //   this.lectureData.push(res.data[i])
            // }
            if (res.data[i].i_status == 1) {
              if (type == 1) {
                this.lectureData.push(res.data[i])
              }else{
                this.courseData.push(res.data[i])
              }
            }
          }
          // function compare(property) {
          //   return function (a, b) {
          //     var value1 = a[property];
          //     var value2 = b[property];
          //     return new Date(value2).getTime() - new Date(value1).getTime();  //降序只需要  return value2- value1
          //   }
          // }
          // this.lectureData.sort(compare('create_date'))
        })
        .catch(res => { });
    },
    //刷新表格数据（带筛选条件）
    refreshCourseData() {
      this.courseData = [];
      this.z_get(
        "api/project/getCourseListLimit",
        {
          condition: "",
          limitNum: 10
        },
        { loading: this.$refs.courseTable } //若数据为从后台返回, 则让ref为loCationTable 的组件显示加载中的状态图标
      )
        .then(res => {
          console.log(res.data)
          for (let i = 0; i < res.data.length; i++) {
            if (new Date(res.data[i].competition_startdate).getTime() < new Date().getTime() && new Date(res.data[i].competition_enddate).getTime() > new Date().getTime()) {
              this.courseData.push(res.data[i])
            }
          }
          function compare(property) {
            return function (a, b) {
              var value1 = a[property];
              var value2 = b[property];
              return new Date(value2).getTime() - new Date(value1).getTime();  //降序只需要  return value2- value1
            }
          }
          this.courseData.sort(compare('competition_startdate'))
        })
        .catch(res => { });
    },
    gotoLecture() {
      // this.$router.replace('/competition/gameRegistration')
      this.$router.replace('/competition/gameRegistration')
    },
    gotoCourse() {
      // this.$router.replace('/courseManage/courseRegistration')
      this.$router.replace('/evaluation/evaluationRegistration')
    },
    openLectureDetail(row) {
      this.lectureContent = row;
      this.$nextTick(() => {
        this.$refs.contentEditor.setContent(this.lectureContent.pi_content);
      });
      this.showLectureDetail = true;
    },
    openCourseDetail(row) {
      this.courseContent = row;
      this.showCourseDetail = true;
    },
  },
  mounted() {
    this.refreshLectureData(1)
    this.refreshLectureData(2)
    this.refreshCourseData()
  }
};
</script>

<style scoped>
/deep/ .el-table__body-wrapper {
  &::-webkit-scrollbar {
    width: 0px;
    border: none;
  }

  &::-webkit-scrollbar-track {
    border: none;
  }
}

/deep/ .el-table th.gutter {
  display: none;
  width: 0
}

/deep/ .el-table colgroup col[name='gutter'] {
  display: none;
  width: 0;
}

/deep/ .el-table__body {
  width: 100%;
}

/* 修改表格中每一行的横线样式 */

/* /deep/ .el-table th, 
/deep/ .el-table tr, 
/deep/ .el-table td {
  border: 5px;
  border-bottom: 10px red;
} */
/deep/ .el-table td.el-table__cell,
/deep/ .el-table th.el-table__cell.is-leaf {
  border-width: 3px !important;
  border-color: rgb(247, 247, 247) !important;
  /* 将横线颜色设置为红色, 你可以根据需要修改颜色值 */
}

.custom-form-item {
  height: 25px;
}

.custom-link {
  display: flex;
  flex: 1;
  cursor: pointer;
  color: #8d9196;
  /* 设置链接文本颜色 */
  /* 添加下划线效果 */
  /* 可以添加其他样式，例如悬停效果、选中效果等 */
}

.custom-link-text {
  /* 自定义链接文本样式，例如字体大小、字体样式等 */
}

/* 悬停时改变链接颜色 */
.custom-link:hover {
  color: #409EFF;
  /* 修改链接文本悬停颜色 */
}
</style>